import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "plan-general-header" }
const _hoisted_3 = { class: "plan-modal" }
const _hoisted_4 = { class: "plan-modal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "w-100 simple-card_list"
}
const _hoisted_8 = {
  key: 1,
  class: "divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['bordered-card simple-card', _ctx.classes])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.title), 1),
        (_ctx.actionButton && _ctx.data.status)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: _ctx.data.to, params: { status: _ctx.data.status } },
              class: "plan-modal text-underline"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.actionButton), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_ctx.actionButton)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: _ctx.data.to },
                class: "text-underline"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.actionButton), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
      ]),
      _hoisted_5
    ]),
    (_ctx.data.type === 'number')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.data.count), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.type === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "w-100"
            }, [
              (item.to)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: item.to },
                    class: "plan-modal fw-normal text-decoration-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true),
              (index < _ctx.data.list.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}